import { useMemo, useState } from "react"

import { PropTypes } from "@l2r-front/l2r-proptypes"
import { FilterButton } from "@l2r-front/l2r-ui"

import { FILTERS } from "../../constants/filters"
import { useVerticalSigningStateContext } from "../../contexts/VerticalSigningContext"

import { VerticalSignFilters } from "../VerticalSignFilters"

export function VerticalSigningFilterButton(props) {

    const {
        className,
        enabledFilters,
    } = props

    const [displayFilters, setDisplayFilters] = useState(false)
    const closeFilters = () => setDisplayFilters(false)
    const toggleFilter = () => setDisplayFilters(displayFilters => !displayFilters)

    const { filters } = useVerticalSigningStateContext()

    const filterCount = useMemo(() => {
        return Object.entries(filters || {}).map(([filterKey, filterValue]) => {
            if (enabledFilters.includes(filterKey)) {
                return filterValue
            } else {
                return []
            }
        }).flat().length
    }, [filters, enabledFilters])

    return <FilterButton className={className} filterCount={filterCount} open={displayFilters} onClick={toggleFilter} onClose={closeFilters}>
        <VerticalSignFilters displayFilters={displayFilters} close={closeFilters} />
    </FilterButton>
}

VerticalSigningFilterButton.defaultProps = {
    enabledFilters: FILTERS,
}

VerticalSigningFilterButton.propTypes = {
    className: PropTypes.string,
    enabledFilters: PropTypes.arrayOf(PropTypes.oneOf(FILTERS)),
}